import { FC, useState, useCallback, useMemo, DetailedHTMLProps, HtmlHTMLAttributes } from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { useHublogbookTableProperties, useAllHubsLogbooks, useAllHubsLogbooksByStatusName, useStatuses } from 'Hooks';
import { NewRequestModal, EditRequestModal } from 'Components';
import { HubsLogbook } from 'Models';
import React from 'react';
import { Box, FormControlLabel, FormGroup, IconButton, Switch, Tooltip } from '@mui/material';
import { CAETable, useCurrentUser, useIsAdmin } from '@cae/component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@mui/styles';
import { APPLICATION_ID } from 'Helpers';

const useStyles = makeStyles({
    root: {
        '& .MuiTableCell-sizeSmall': {
            padding: 1
        }
    }
}); 

const defaultStatus = "PENDING";
export const Application: FC<DetailedHTMLProps<HtmlHTMLAttributes<HTMLDivElement>, HTMLDivElement>> = props => {
    const [selectedStatuses, setSelectedStatuses] = useState<string[]>([defaultStatus]);
    const [isNewRequestModalOpen, setNewRequestModalIsOpen] = useState<boolean>(false);
    const { statuses } = useStatuses();
    const [hubsLogbooks, setHubsLogbooks] = useState<HubsLogbook[]>([]);
    const allPendingHubLogbooksState = useAllHubsLogbooksByStatusName(defaultStatus);
    const isLoading = allPendingHubLogbooksState.isLoading;
    const allHubsLogbooks = useAllHubsLogbooks();
    const { isAdmin } = useIsAdmin(APPLICATION_ID);
    const classes = useStyles();
    const user = useCurrentUser();

    const [selectedEditHubsLogbook, setSelectedEditHubsLogbook] = useState<HubsLogbook>();

    React.useEffect(() => {
        setHubsLogbooks(allPendingHubLogbooksState.hubsLogbooks)
    }, [allPendingHubLogbooksState.hubsLogbooks]);

    React.useEffect(() => {
        setHubsLogbooks(allHubsLogbooks.hubsLogbooks)
    }, [allHubsLogbooks.hubsLogbooks]);

    const handleOnClickEditRow = useCallback((rowData: HubsLogbook) => {
        setSelectedEditHubsLogbook(rowData);
    }, []);

    const tableProperties = useHublogbookTableProperties(handleOnClickEditRow);

    const filteredHubsLogbooks = useMemo(() => {
        if (selectedStatuses.length === 0) {
            return hubsLogbooks.map( h => {h.isNotEditable = (isAdmin || user?.user.username === h.originator)? "false" : "true"; return h})
        } else {
            let test = hubsLogbooks.map( h =>{h.isNotEditable = (isAdmin || user?.user.username === h.originator)? "false":"true"; return h});
            return test.filter(h => selectedStatuses.includes(h.status));
        }
    }, [hubsLogbooks, selectedStatuses, isAdmin, user])

    const handleOnChangeFilterStatus = useCallback((status: string, checked: boolean) => {
        if (checked) {
            setSelectedStatuses(prevState => [ ...prevState, status]);
        } else {
            setSelectedStatuses(prevState => prevState.filter(s => s !== status));
        }
    }, [setSelectedStatuses]);

    const handleOnAddNewRequest = useCallback((hubsLogbook: HubsLogbook) => {
        setHubsLogbooks(prevState => [ ...prevState, hubsLogbook ]);
    }, [setHubsLogbooks]);

    const habdleOnEditRequest = useCallback((hubsLogbook: HubsLogbook) => {
        setHubsLogbooks(prevState => {
            const hubsLogbooks = [ ...prevState ];
            const editedHubsLogbookIndex = hubsLogbooks.findIndex(h => h.id === hubsLogbook.id);
            hubsLogbooks[editedHubsLogbookIndex] = hubsLogbook;

            return hubsLogbooks;
        });
    }, [setHubsLogbooks]);

    return (
        <div { ...props }>
            <CAETable
                muiTableProps={{
                    className: classes.root
                }}
                isLoading={isLoading}
                properties={tableProperties}
                rows={filteredHubsLogbooks as any}
                pagination
                filterType="multi"
                defaultRowsPerPage={10}
                excelExtractProperties={{
                    fileName: `HubsLogbook - ${new Date().toDateString()}`,
                    type: "filtered"
                }}
                toolbarContainer={(
                    <Box display="flex" justifyContent="space-between">
                        <FormGroup row>
                            {statuses.map(status => (
                                <FormControlLabel
                                    labelPlacement="top"
                                    label={status}
                                    control={(
                                        <Switch
                                            size="small"
                                            key={status}
                                            checked={selectedStatuses.includes(status)}
                                            onChange={(e, checked) => handleOnChangeFilterStatus(status, checked)}
                                        />
                                    )}
                                />
                            ))}
                        </FormGroup>    
                        <Box>
                            <Tooltip title="Add new Request">
                                <IconButton onClick={() => setNewRequestModalIsOpen(true)}><FontAwesomeIcon icon={faPlus} /></IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                )}
            />
            <NewRequestModal onAddNewRequest={handleOnAddNewRequest} open={isNewRequestModalOpen} setOpen={setNewRequestModalIsOpen} isAdmin={isAdmin}/>
            <EditRequestModal onEditRequest={habdleOnEditRequest} open={selectedEditHubsLogbook !== undefined} onClose={() => setSelectedEditHubsLogbook(undefined)} hubsLogbook={selectedEditHubsLogbook} isAdmin={isAdmin}/>
        </div>
    )
};

export default Application;